/**
 * Asynchronously loads the component for ReceiptBooking
 */
import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
})
